import React, { Component, useEffect } from "react";
import {Table, Glyphicon, OverlayTrigger} from 'react-bootstrap';
import { UserService } from "../Services/UserService";
import { RouteService } from "../Services/RouteService";
import { tooltip, HtmlTooltip } from '../Utils';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {Typeahead} from 'react-bootstrap-typeahead';
// import Collapsible from '../components/Collapsible';
import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SaveIcon from '@material-ui/icons/Save';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { withStyles, Grid, colors, AppBar } from "@material-ui/core";
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import { useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { ROLES } from "../Roles";
import { Color } from "../Constants";

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
};
// const grid = 8;
const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "white",
    // padding: grid,
    width: '100%'
});

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    //padding: grid * 2,
    //margin: `0 0 ${grid}px 0`,
    width: '100%',
  
    // change background colour if dragging
    background: isDragging ? "#81c784" : "#fafafa",
  
    // styles we need to apply on draggables
    ...draggableStyle
});

const styles = theme =>({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      borderRadius: 0
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    divider: {
        backgroundColor: colors.grey[300]
    },
});


class StoreRouteMapping extends Component {

    constructor(props) {
        super(props);

        this.state = {
            defaultTab: 0,
            storeListUI: [],
            masterStores: [],
            masterRoutes: [],
            show: false,
            selectedRoute: {},
            selectedStore: {},
            routeRows: [],
            data: [],

            columns : [
                { id: 'store_name', align: 'left', numeric: false, disablePadding: false, label: 'Store' , sortable: false },
                { id: 'flat', align: 'left', numeric: false, disablePadding: false, label: 'Address', sortable: false  },
                { id: 'route_id', align: 'left', numeric: false, disablePadding: false, label: 'Route', sortable: false  },
                { id: 'actions', numeric: false, disablePadding: false, label: 'Actions', sortable: false  },
            ],
            order: 'asc',
            orderBy: 'store_name',

            sort_stores: [],
            sort_route: null,
            sortingEnabled: false
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.assignRoute = this.assignRoute.bind(this);
        this.handleAssign = this.handleAssign.bind(this);
        this.removeRouteAssignment = this.removeRouteAssignment.bind(this);
    }

    
    componentDidMount(){
        this.props.setTitle('Store > Route Mapping');
        this.props.isLoading(true);
        this.props.showProgressDialog();
        this.fetchMasterStores();
    }

    handleClose() {
        this.setState({ show: false , selectedRoute: {}, selectedStore: {}});
    }

    handleShow() {
        this.setState({ show: true });
    }

    fetchMasterStores(){
        this.props.isLoading(true);
        UserService.getStoreList(0, 10000, '', '', '', '0,1,2')
        .then((data) => {
            console.log(data);
            this.setState({masterStores: data.users}, () => this.fetchMasterRoutes());
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchMasterRoutes(){
        RouteService.getRouteList()
        .then((data) => {
            console.log(data);
            this.setState({
                masterRoutes: data.routes
            }, () => this.fetchStoreRouteMapping());
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchStoreRouteMapping(){
        this.props.isLoading(true);
        let rows = [];
        let routeRows = [];
        let routeMap = new Map();
        RouteService.getStoreRouteMappings()
        .then((data) => {
            console.log(data);

            if(this.state.masterStores.length > 0 && this.state.masterRoutes.length > 0){
                let masterRoutes = this.state.masterRoutes, masterStores = this.state.masterStores;
                this.state.masterStores.forEach((user) => {
                    //this.fetchStoreContracts(user.id);
                    delete user.route;
                    let routeMapping = data.store_route_mapping.filter((mapping) => mapping.store_id === user.id)[0];
                    if(routeMapping){
                        user.route =  masterRoutes.filter((route) => route.id === routeMapping.route_id)[0];
                    }
                    rows.push(<UserDetails 
                                key={user.id} 
                                user={user} 
                                assignRoute={this.assignRoute} 
                                removeRouteAssignment={this.removeRouteAssignment}
                                roles={this.props.user.roles}
                                />);
                });

                data.store_route_mapping.forEach((mapping) => {
                    let a = [];
                    if(routeMap.has(mapping.route_id)){
                        a = routeMap.get(mapping.route_id);
                    }
                    let store = masterStores.filter((store) => store.id === mapping.store_id)[0];
                    // if(store){
                        // console.log(mapping, store);
                        store.sort_order = mapping ? mapping.sort_order : 0;
                        a.push(store);
                        routeMap.set(mapping.route_id, a);
                    // }
                });
                routeMap.forEach((value, key, map) => {
                    let route =  masterRoutes.filter((route) => route.id === key)[0];
                    routeRows.push(
                        <RouteDetails 
                            key={key} 
                            title={route.name} 
                            route={route} 
                            data={value} 
                            sortingEnabled={this.state.sortingEnabled}
                            assignRoute={this.assignRoute} 
                            removeRouteAssignment={this.removeRouteAssignment} 
                            roles={this.props.user.roles}
                            {...this.props}/>
                    );
                });

                this.setState({
                    storeListUI: rows,
                    routeRows: routeRows
                });
            }
            this.props.isLoading(false);
            this.props.closeProgressDialog();
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
            this.props.closeProgressDialog();
        });
    }

    assignRoute(e, user, isRouteAssigned){
        e.preventDefault();
        this.handleShow();
        if(isRouteAssigned){
            let route = this.state.masterRoutes.filter((route) => {
                return route.id === user.route.id;
            });
            if(route)
                this.setState({selectedRoute: route});
        }
        this.setState({selectedStore: user});
    }

    handleAssign(){
        console.log(this.state.selectedRoute.id, this.state.selectedStore.id);
        if(this.state.selectedRoute.id && this.state.selectedStore.id){
            let body = {
                        route_id: this.state.selectedRoute.id, 
                        store_id: this.state.selectedStore.id
                    };
            RouteService.assignRouteToStore(body, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                console.log(data);
                this.handleClose();
                this.fetchStoreRouteMapping();
            })
            .catch((error) => {
                console.log(error);
                this.props.showConfirmDialog('Something went wrong. Please check again later.', undefined, undefined);
            });
        }
    }

    removeRouteAssignment(e, user){
        e.preventDefault();
        this.props.showConfirmDialog('Confirm removal of Route assignment?', undefined, () =>{
            RouteService.removeStoreRouteAssignment(user.route.id, user.id, {'user-id' : this.props.user.id, 'user-name': this.props.user.name })
            .then((data) => {
                console.log(data);
                if(data.success){
                    this.fetchStoreRouteMapping();
                    this.props.closeConfirmDialog();
                } else {
                    this.props.showConfirmDialog(data.message, undefined, undefined);
                }
            })
            .catch((error) => {
                console.log(error);
                this.props.showConfirmDialog("Cannot remove assignment. Please try again later.", undefined, undefined);
            });
        });
        console.log("Remove route assignment for Store: " + user.store_name);
    }

    handleChange = (event, newValue) => {
        this.setState({defaultTab : newValue})
    }

    render() {
        let classes = this.props.classes;

        return (
            <div className="Home">
                <div className="container">
                    <AppBar position="static" elevation={0}>
                        <Tabs 
                            value={this.state.defaultTab} 
                            onChange={this.handleChange}
                        >
                            <Tab eventkey={1} label="Store List"/>
                            <Tab eventkey={2} label="Routewise List"/>
                        </Tabs>
                    </AppBar>
                    <Divider className={classes.divider} />
                    {this.state.defaultTab === 0 && 
                        <Paper className={classes.root} style={{width: "100%", marginTop: 0, paddingLeft: "5px", paddingRight: "5px"}}>
                            {this.storeList()}
                        </Paper>
                    }
                    {this.state.defaultTab === 1 && 
                            this.routeList()
                    }
                    <DialogMUI
                        disableBackdropClick
                        open={this.state.show}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        scroll='body'>
                            <DialogTitle id="alert-dialog-title">Assign Route</DialogTitle>
                            <DialogContent style={{minHeight: '250px', minWidth: 350}}>
                                <DialogContentText id="alert-dialog-description" component={'span'}>
                                    <Divider />
                                    <Typeahead
                                        id="typeahead-id-store-route-map"
                                        onChange={(selected) => {
                                            this.setState({ selectedRoute: selected[0] });
                                        }}
                                        options={this.state.masterRoutes}
                                        labelKey="name"
                                        placeholder="Choose a Route"
                                        clearButton
                                        maxHeight='180px'
                                        //defaultSelected ={this.state.selectedAgent}
                                    />
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose} color="primary">
                                    Cancel
                                </Button>
                                <Button onClick={this.handleAssign} color="primary" autoFocus>
                                    Assign
                                </Button>
                            </DialogActions>
                    </DialogMUI>
                </div>
            </div>
        );
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => {

        });
    }

    storeList(){
        return (
            <Table striped condensed hover responsive>
                <EnhancedTableHead
                    order={this.state.order}
                    orderBy={this.state.orderBy}
                    onRequestSort={this.sortBy}
                    rows ={this.state.columns} />
                <TableBody>
                    {this.state.storeListUI}
                </TableBody>
            </Table>
        );
    }

    storeListOld(){
        return (
            <Table striped condensed hover responsive>
                <thead>
                        <tr>
                            <th>Store</th>
                            <th>Address</th>
                            <th>Route</th>
                            <th>Action</th>
                        </tr>
                </thead>
                <tbody style={{textAlign: "left"}}>
                    {this.state.storeListUI}
                </tbody>
            </Table>
        );
    }

    routeList(){
        return this.state.routeRows
    }

}

class UserDetails extends Component {

    render(){
        const user = this.props.user;
        const isRouteAssigned = user.route ? true : false;
        const roles = this.props.roles;
        return (
            <HtmlTooltip arrow title={ user.status === "0" ? "The store is deactive" : user.status === "2" ? "Paused" : ""}>
                <tr className={user.status === "0" ? "danger" : ""} style={user.status === "2" ? {backgroundColor: Color.yellow}: {}}>
                    <td align="justify" style={{width: "30%"}}>{user.store_name}</td>
                    <td align="justify" style={{width: "45%"}}>{user.flat}</td>
                    <td align="justify" style={{width: "20%"}}>{user.route ? user.route.name: "-"}</td>
                    <td align="justify" style={{width: "5%"}}>
                        {
                            (roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN)) && 
                            (   (user.status === "1" || user.status === "2") &&
                                <OverlayTrigger placement="bottom" overlay={tooltip(isRouteAssigned ? "Reassign" : "Assign")}>
                                    <Glyphicon glyph="circle-arrow-up" style={{marginRight: "10px"}} onClick={(e) => this.props.assignRoute(e, user, isRouteAssigned)}/>
                                </OverlayTrigger>
                            )
                        }
                        {
                            (roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN)) && 
                            ( isRouteAssigned ? (
                                    <OverlayTrigger placement="bottom" overlay={tooltip("Remove Assignment")}>
                                        <Glyphicon glyph="remove" style={{marginRight: "10px"}} onClick={(e) => this.props.removeRouteAssignment(e, user)}/>
                                    </OverlayTrigger>
                                ) : null
                            )
                        }
                    </td>
                </tr>
            </HtmlTooltip>
      );
    }
}

function RouteDetails(props){

    const [data, setData] = useState([]);
    const [title, setTitle] = useState('');
    const {sortingEnabled} = props.sortingEnabled;
    const [sorting, setSorting] = useState(false);
    const {roles} = props;

    useEffect(() => {
        if(props.data){
            setData(props.data.sort((first, second) => first.sort_order - second.sort_order));
        }
        if(props.title){
            setTitle(props.title);
        }

        return () => {
            setData([]);
        }
    }, [props])


    const onDragEnd = (result) => {
        setSorting(true);
        // dropped outside the list
        if (!result.destination) {
          return;
        }
    
        const originalData = reorder(
          data,
          result.source.index,
          result.destination.index
        );

        let oldObj = originalData[result.source.index];
        let newObj = originalData[result.destination.index];

        oldObj.sort_order = result.source.index;
        newObj.sort_order = result.destination.index;
    
        setData(originalData);
    }

    const saveOrder = e => {
        if(this.state.sortingEnabled){
            props.showConfirmDialog("Confirm Save order?", undefined, saveRouteOrder);
        } else {
            props.showSnackBar(`This feature has been Disabled`, 'warning');
        }
    }

    const saveRouteOrder = () => {
        props.closeConfirmDialog();
        let body = {};
        
        body.stores = data.map((p,i) => ({
            store_id: p.id,
            sort_order: i
        }));
        body.route_id = props.route.id;
        body.route_name = props.route.name;

        RouteService.saveOrder({'user-id' : props.user.id, 'user-name': props.user.name }, body)
        .then(() => {
            props.isLoading(false);
            props.showSnackBar(`Order Saved`, 'success');
            setSorting(false);
        })
        .catch(() => {
            props.isLoading(false);
            props.showConfirmDialog("Failed to save Order. Please try again.", undefined, undefined);
        });
    }

    return (
        <ExpansionPanel square style={{margin: 'auto', marginBottom: 1}}>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
            <Grid container alignItems="center" justify="flex-start">
                <Grid item xs={12} lg={8}>
                    <Typography variant="subtitle1" align="left">{title}</Typography>
                </Grid>
                <Grid item xs={12} lg={4}>
                    { 
                        sorting && (
                            <div 
                                style={{textAlign: 'right', marginRight: 24}}
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    onClick={saveOrder}>
                                    Save Order
                                </Button>
                            </div>
                        )
                    } 
                </Grid>
            </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <Grid container alignItems="flex-start" justify="flex-end">
                    <Grid item xs={12} lg={12}>
                        <DragDropContext key={"stores"} onDragEnd={onDragEnd}>
                            <Table striped condensed hover>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Store</th>
                                        <th>Address</th>
                                        <th>Manager name</th>
                                        <th>Contact No</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <tbody
                                        {...provided.droppableProps}
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        {data.map((d,i) => 
                                            <RouteStoreDetails 
                                                key={d.id} 
                                                user={d} 
                                                index={i}
                                                sortingEnabled={sortingEnabled}
                                                assignRoute={props.assignRoute} 
                                                removeRouteAssignment={props.removeRouteAssignment}
                                                roles={roles}/>
                                        )}
                                        {provided.placeholder}
                                    </tbody>
                                )}
                                </Droppable>
                            </Table>
                        </DragDropContext>
                    </Grid>
                </Grid>
            </ExpansionPanelDetails>
        </ExpansionPanel>
    );
}

class RouteStoreDetails extends Component {

    render(){
        const user = this.props.user;
        const isRouteAssigned = user.route ? true : false;
        const sortingEnabled = this.props.sortingEnabled || false;
        const roles = this.props.roles;
        return sortingEnabled ? 
            (
                <Draggable draggableId={user.id} index={this.props.index}>
                    {(provided, snapshot) => (
                        <HtmlTooltip arrow title={ user.status === "0" ? "The store is deactive" : user.status === "2" ? "Paused" : ""}>
                            <tr className={user.status === "0" ? "danger" : ""}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={ snapshot.isDragging ? getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                            ) : user.status === "2" ? {backgroundColor: Color.yellow}: {}}>
                                <td>
                                    <HtmlTooltip title="Click and Drag to Re-arrange">
                                        <DragHandleIcon />
                                    </HtmlTooltip>
                                </td>
                                <td align="left">{user.store_name}</td>
                                <td align="left" style={{display: snapshot.isDragging ? "none" : "table-cell"}}>{user.flat}</td>
                                <td align="left" style={{display: snapshot.isDragging ? "none" : "table-cell"}}>{user.name}</td>
                                <td align="left" style={{display: snapshot.isDragging ? "none" : "table-cell"}}>{user.mobile_no}</td>
                                <td style={{display: snapshot.isDragging ? "none" : "table-cell"}}>
                                    {
                                        (roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN)) && 
                                        <OverlayTrigger placement="bottom" overlay={tooltip(isRouteAssigned ? "Reassign" : "Assign")}>
                                            <Glyphicon glyph="circle-arrow-up" style={{marginRight: "10px"}} onClick={(e) => this.props.assignRoute(e, user, isRouteAssigned)}/>
                                        </OverlayTrigger>
                                    }
                                    {
                                        (roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN)) && 
                                        ( isRouteAssigned ? (
                                                <OverlayTrigger placement="bottom" overlay={tooltip("Remove Assignment")}>
                                                    <Glyphicon glyph="remove" style={{marginRight: "10px"}} onClick={(e) => this.props.removeRouteAssignment(e, user)}/>
                                                </OverlayTrigger>
                                            ) : null
                                        )
                                    }
                                </td>
                            </tr>
                        </HtmlTooltip>
                    )}
                </Draggable>
            )
        :
            (
                <HtmlTooltip arrow title={ user.status === "0" ? "The store is deactive" : user.status === "2" ? "Paused" : ""}>
                    <tr className={user.status === "0" ? "danger" : ""} style={user.status === "2" ? {backgroundColor: Color.yellow}: {}}>
                        <td>
                        </td>
                        <td align="left">{user.store_name}</td>
                        <td align="left" style={{display: "table-cell"}}>{user.flat}</td>
                        <td align="left" style={{display: "table-cell"}}>{user.name}</td>
                        <td align="left" style={{display: "table-cell"}}>{user.mobile_no}</td>
                        <td style={{display: "table-cell"}}>
                            {
                                (roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN)) && 
                                <OverlayTrigger placement="bottom" overlay={tooltip(isRouteAssigned ? "Reassign" : "Assign")}>
                                    <Glyphicon glyph="circle-arrow-up" style={{marginRight: "10px"}} onClick={(e) => this.props.assignRoute(e, user, isRouteAssigned)}/>
                                </OverlayTrigger>
                            }
                            {
                                (roles.includes(ROLES.STORE_MANAGEMENT) || roles.includes(ROLES.ADMIN)) && 
                                ( isRouteAssigned ? (
                                        <OverlayTrigger placement="bottom" overlay={tooltip("Remove Assignment")}>
                                            <Glyphicon glyph="remove" style={{marginRight: "10px"}} onClick={(e) => this.props.removeRouteAssignment(e, user)}/>
                                        </OverlayTrigger>
                                    ) : null
                                )
                            }
                        </td>
                    </tr>
                </HtmlTooltip>
            )
        ;
    }
}

export default withStyles(styles)(StoreRouteMapping);